




































































































































































































































































import { Component, Watch } from 'vue-property-decorator';
import Mixin from '@/mixin';
import VDatePicker from '@/components/items/VDatePicker.vue';
import departmentService from '@/services/common/department.service';
import authModule from '@/store/modules/common/auth.module';
import { dateFilter } from '@/config/filter';
import { now } from 'moment';
import companyService from '@/services/common/company.service';
import coachService from '@/services/common/coach.service';
import { Coach } from '@/store/models';
import popupModule from '@/store/modules/common/popup.module';
import popup from '@/data/popup.json';
import reportViewModel, { ReportParam } from './reportViewModel';
const moment = require('moment');

@Component({
  name: 'Report',
  components: { VDatePicker }
})
export default class Report extends Mixin {
  public startDate: string | null = null;
  public endDate: string | null = null;
  public reportPeriod: string | null = 'all';
  public reportType: 'overall' | 'department' | 'individual' = 'overall';
  public reportFormat: 'table' | 'chart' = 'chart';
  public departments: string[] = [];
  public department: string = '';
  public individuals: Coach[] = [];
  public coachId: string = '';
  public companies: string[] = [];
  public company: string = '';
  public individualMap: Map<string, Coach[]> = new Map();

  get formDisable() {
    return this.company === '' && this.isShowCompanyDropdown;
  }

  get isShowCompanyDropdown() {
    return (
      authModule.user?.role === 'Administrator' || process.env.VUE_APP_FULL_MENU
    );
  }

  public getFromDate() {
    switch (this.reportPeriod) {
      case '30':
      case '60':
      case '90':
        return dateFilter(
          moment()
            .subtract(this.reportPeriod, 'days')
            .toDate()
        );
      case 'all':
        return dateFilter(moment('2020-01-01').toDate());
      case 'during':
        return dateFilter(this.startDate);
      default:
        return dateFilter(now());
    }
  }

  public getToDate() {
    switch (this.reportPeriod) {
      case '30':
      case '60':
      case '90':
        return dateFilter(now());
      case 'during':
        return dateFilter(this.endDate);
      default:
        return dateFilter(now());
    }
  }

  public departmentQuery() {
    if (this.reportType === 'department') {
      return `&department=${this.department}`;
    }
    return '';
  }

  public individualQuery() {
    if (this.reportType === 'individual') {
      return `&coachId=${this.coachId}`;
    }
    return '';
  }

  public gotoReport() {
    if (!this.validate()) {
      this.showPopup(true);
      return
    };
    // if (this.reportType != 'individual') {
    //   this.goTo(
    //     `/report-detail/${this.reportFormat || 'table'}?type=${
    //       this.reportType
    //     }&fromDate=${this.getFromDate()}&toDate=${this.getToDate()}${this.departmentQuery()}&companyName=${
    //       this.company
    //     }`
    //   );
    // } else {
    //   this.goTo(
    //     `/report-detail-individual/${this.reportFormat || 'table'}?type=${
    //       this.reportType
    //     }&fromDate=${this.getFromDate()}&toDate=${this.getToDate()}${this.individualQuery()}&companyName=${this.company}`
    //   );
    // }
    const queries = {
      'type': this.reportType,
      'fromDate': this.getFromDate(),
      'toDate': this.getToDate(),
    };
    let params: any = {
      path: `/report-detail-individual/${this.reportFormat || 'table'}`,
      query: {
        ...queries,
        'coachId': this.coachId,
      }
    };
    if (this.reportType != 'individual') {
      params = {
        path: `/report-detail/${this.reportFormat || 'table'}`,
        query: {
          ...queries,
          'department': this.department,
          'companyName': this.company,
        }
      };
    }
    this.goTo(params)
  }
  @Watch('reportPeriod', { deep: true, immediate: true })
  public resetDateTime() {
    if (this.reportPeriod !== 'during') {
      this.startDate = null;
      this.endDate = null;
    }
  }
  @Watch('startDate', { deep: true, immediate: true })
  public updateStartDate() {
    if (this.startDate) {
      this.reportPeriod = 'during';
    }
  }
  @Watch('endDate', { deep: true, immediate: true })
  public updateEndDate() {
    if (this.endDate) {
      this.reportPeriod = 'during';
    }
  }

  @Watch('company', { deep: true, immediate: true })
  public reloadCompany() {
    if (this.company !== '') {
      this.coachId = '';
      this.department = '';
      this.departments = [];
      this.loadIndividuals();
      this.loadDepartments();
    }
  }

  @Watch('reportType', { deep: true, immediate: true })
  public reloadIndividuals() {
    switch (this.reportType) {
      case 'individual': {
        this.loadIndividuals();
        this.department = '';
        break
      }
      case 'department': {
        this.loadDepartments();
        this.coachId = '';
        break
      }
      default: {
        this.department = '';
        this.coachId = '';
        break
      }
    }
  }

  public async loadIndividuals() {
    if (this.individualMap.get(this.company)?.length || -1 > 0) {
      this.individuals = [...this.individualMap.get(this.company)];
    } else {
      const _individuals = [
        ...(await coachService.loadCoachByCompany({
          companyName: this.company
        }))
      ];
      this.individualMap.set(this.company, _individuals);
      this.individuals = [...this.individualMap.get(this.company)];
    }
  }

  public async loadDepartments() {
    this.departments = [
      ...(await departmentService.loadDepartments(this.company))
    ];
  }

  public async loadCompanies() {
    if (this.companies.length > 0) {
      return this.companies;
    }
    this.companies = [...(await companyService.loadCompanies())];
  }

  public async showPopup(isShow: boolean) {
    await Promise.all([
      popupModule.initPopup(popup.selectDatetime),
      popupModule.setShowPopup(isShow)
    ]);
  }

  validate() {
    if (this.reportPeriod === 'during') {
      if (!this.startDate || !this.endDate) {
        return false
      }
    }

    return true
  }

  mounted() {
    if (this.isShowCompanyDropdown) {
      this.loadCompanies();
      if (window.sessionStorage.getItem('REPORT_COMPANY')) {
        this.company = window.sessionStorage.getItem('REPORT_COMPANY') || '';
      }
    } else {
      this.company = authModule.user?.companyName || '';
    }
    window.localStorage.setItem('REPORT_SORTING', '')
    window.localStorage.setItem('FILTER_COACH_CLIENT_ID', '')
    // if (this.isShowCompanyDropdown) return;

    if (window.sessionStorage.getItem('REPORT_TYPE')) {
      this.reportType = window.sessionStorage.getItem('REPORT_TYPE') as 'overall' | 'department' | 'individual'
    }
    if (window.sessionStorage.getItem('REPORT_PERIOD')) {
      this.reportPeriod = window.sessionStorage.getItem('REPORT_PERIOD')
    }
    if (window.sessionStorage.getItem('REPORT_FROM_DATE') && this.reportPeriod === 'during') {
      this.startDate = window.sessionStorage.getItem('REPORT_FROM_DATE')
    }
    if (window.sessionStorage.getItem('REPORT_TO_DATE') && this.reportPeriod === 'during') {
      this.endDate = window.sessionStorage.getItem('REPORT_TO_DATE')
    }
    reportViewModel.clean();
  }

  updated() {
    // if (this.isShowCompanyDropdown) return;
    if (window.sessionStorage.getItem('REPORT_DEPARTMENT') &&
      !this.department &&
      this.reportType === 'department') {
      this.department = window.sessionStorage.getItem('REPORT_DEPARTMENT') || ''
    }
    if (window.sessionStorage.getItem('REPORT_MANAGER_ID') &&
      !this.coachId &&
      this.reportType === 'individual') {
      this.coachId = window.sessionStorage.getItem('REPORT_MANAGER_ID') || ''
    }
  }

  destroyed() {
    if (this.company) {
      window.sessionStorage.setItem('REPORT_COMPANY', this.company);
    }
    if (this.reportPeriod) {
      window.sessionStorage.setItem('REPORT_PERIOD', this.reportPeriod);
    }
    const fromDate = this.getFromDate();
    if (fromDate) {
      window.sessionStorage.setItem('REPORT_FROM_DATE', fromDate);
    }
    const toDate = this.getToDate();
    if (toDate) {
      window.sessionStorage.setItem('REPORT_TO_DATE', toDate);
    }
    window.sessionStorage.setItem('REPORT_TYPE', this.reportType);
    window.sessionStorage.setItem('REPORT_DEPARTMENT', this.department);
    window.sessionStorage.setItem('REPORT_MANAGER_ID', this.coachId);
    // Set fields to view model
    const reportParam: ReportParam = {
      startDate: fromDate,
      endDate: toDate,
      reportType: this.reportType,
      reportPeriod: this.reportPeriod ?? 'all',
      department: this.department,
      coachId: this.coachId,
      company: this.company
    }
    reportViewModel.initReportParams(reportParam)
  }
}
